import React from "react";
import PropTypes from "prop-types";
import { buildScopeTranslate } from "lib/I18n";

const tNav = buildScopeTranslate("views.content.agentforce.assessments.navigation");

const Breadcrumb = ({ showProgress = false, currentQuestionIndex = 0, totalQuestions = 0, onBackClick, onInfoClick, onFeedbackClick = () => {}, showFeedbackButton = true }) => {
  const progress = totalQuestions > 0 ? ((currentQuestionIndex + 1) / totalQuestions) * 100 : 0;

  return (
    <nav aria-label={tNav("assessment_navigation")} className="slds-border_bottom th-agentforce-assessment__nav">
      <div className="slds-container_center th-agentforce-assessment__nav-inner">
        <div className="slds-grid slds-grid_align-spread slds-grid_vertical-align-center th-agentforce-assessment__nav-row">
          <div className="slds-col th-agentforce-assessment__nav-left">
            <button
              type="button"
              className="slds-button slds-button_icon"
              aria-label={tNav("back_button")}
              data-testid="breadcrumb-back-btn"
              onClick={onBackClick}>
              <tds-icon symbol="chevronleft" size="medium" aria-hidden="true"></tds-icon>
            </button>
            <span className="th-agentforce-assessment__nav-divider"></span>
            <span className="slds-text-heading_small">{tNav("back_button")}</span>
            {showProgress && (
              <div
                role="img"
                tabIndex="0"
                aria-label={tNav("x_of_y_complete", { current: currentQuestionIndex + 1, total: totalQuestions })}
                className="th-agentforce-assessment__nav-progress"
                data-testid="question-progress">
                <span className="th-agentforce-assessment__nav-progress-text" aria-hidden="true">·</span>
                <span className="th-agentforce-assessment__nav-progress-text" aria-hidden="true">
                  {currentQuestionIndex + 1}/{totalQuestions}
                </span>
                <div className="th-agentforce-assessment__nav-progress-bar" aria-hidden="true">
                  <tds-progress-bar progress={progress} size="small" data-testid="breadcrumb-progress"></tds-progress-bar>
                </div>
              </div>
            )}
          </div>
          <div className="slds-col slds-shrink th-agentforce-assessment__nav-right">
            {showFeedbackButton !== false && (
              <tds-tooltip placement="bottom">
                <button type="button" slot="trigger" onClick={onFeedbackClick} className="slds-button slds-button_icon th-agentforce-assessment__icon-button" aria-label={tNav("feedback_button")} data-testid="breadcrumb-chat-btn">
                  <tds-icon symbol="answer" size="small" aria-hidden="true"></tds-icon>
                </button>
                <span slot="tooltip">{tNav("feedback_button")}</span>
              </tds-tooltip>
            )}
            <tds-tooltip placement="bottom">
              <button type="button" slot="trigger" onClick={onInfoClick} className="slds-button slds-button_icon th-agentforce-assessment__icon-button" aria-label={tNav("info_button")} data-testid="breadcrumb-info-btn">
                <tds-icon symbol="info_alt" size="small" aria-hidden="true"></tds-icon>
              </button>
              <span slot="tooltip">{tNav("info_button")}</span>
            </tds-tooltip>
            <tds-tooltip placement="bottom">
              <a
                slot="trigger"
                href={tNav("help_url")}
                target="_blank"
                rel="noopener noreferrer"
                className="slds-button slds-button_icon th-agentforce-assessment__icon-button"
                aria-label={tNav("help_button")}
                data-testid="breadcrumb-help-btn">
                <tds-icon symbol="help" size="small" aria-hidden="true"></tds-icon>
              </a>
              <span slot="tooltip">{tNav("help_button")}</span>
            </tds-tooltip>
          </div>
        </div>
      </div>
    </nav>
  );
};

Breadcrumb.propTypes = {
  showProgress: PropTypes.bool,
  currentQuestionIndex: PropTypes.number,
  totalQuestions: PropTypes.number,
  onBackClick: PropTypes.func.isRequired,
  onInfoClick: PropTypes.func.isRequired,
  onFeedbackClick: PropTypes.func,
  showFeedbackButton: PropTypes.bool,
};

export default Breadcrumb;
